import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class SesionService {
  identity;
  constructor(private _userService: UserService,private _route: ActivatedRoute, private _router: Router) { 
    this.identity = this._userService.getIdentity();
    //console.log(this.identity);
    if(this.identity == null){
			this._router.navigate(["/login"]);
		}
    //console.log("sesion service");
  }
}
